import React, { useEffect, useState } from "react";
import Amenities from "./amenities";
import Faq from "./faq";
import Modal from "../Modal/modal";
import Navbar from "../Navbar/navbar";
import ChatOverlay from "./ChatOverlay";
import PreArrivalModal from "../Modal/preArrivalModal";
import { baseUrl } from "../../Environments/environment";
import axios from "axios";
import WifiModal from "../Modal/wifiModal";
import ThanksgiftModal from "../Modal/thanksgiftModal";
import { useParams, useNavigate } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { useSelector, useDispatch } from "react-redux";
import {
	filterAddOnRequests,
	filterCheckInOutRequsts,
	setGuestAddons,
	setGuestCheckInOutRequests,
} from "../../redux/addOn/addOnSlice";
import { CheckInAddOn } from "../CheckIn/Addon/CheckInAddon";
import ServiceContainer from "./ServiceContainer";
import DoNotDisturb from "./DoNotDisturb";
import { FaArrowLeft } from 'react-icons/fa';

const getFormattedDate = () => {
	const today = new Date();
	const month = String(today.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11, so add 1
	const day = String(today.getDate()).padStart(2, "0");
	const year = today.getFullYear();

	return `${month}/${day}/${year}`;
};
const Home = () => {
	const guestid = useParams();
	const guestSessionId = guestid.id;
	const navigate = useNavigate();
	const [guest, setGuest] = useState(null);
	const [propertyMobile, setPropertyMobile] = useState(null);
	const [propertyLogo, setPropertyLogo] = useState(null);
	const [statusFlow, setStatusFlow] = useState(null);
	const [amenities, setAminities] = useState(null);
	const [overlayVisible, setOverlayVisible] = useState(true);
	const [isWifiModalOpen, setIsWifiModalOpen] = useState(false);
	const [propertyLateCheckOutTime, setPropertyLateCheckOutTime] = useState("");
	const [propertyCheckOutTime, setPropertyCheckOutTime] = useState("");
	const [selectedTime, setSelectedTime] = useState(propertyCheckOutTime);
	const [selectedDate, setSelectedDate] = useState(getFormattedDate());
	const [addOns, setAddOns] = useState(null);
	const [multiGuestSessionId, setMultiGuestSessionId] = useState('');

	const dispatch = useDispatch();
	const storeAddOns = useSelector((state) => state.addOn);
	const overlays = [
		{
			heading: "Respond immediately",
			name: "Front Desk Support",
			number: "+11234567890",
		},
	];

	const getGuest = async () => {
		try {
			console.warn("GUEST SESSION ID->", guestSessionId);
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/guest`,
			);
			console.warn(response.data);
			setGuest(response.data.result);
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	const getGuestPropertyData = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/property`,
			);
			const { countryCode, phoneNumber } =
				response.data.result.guestPropertyMobile;
			setPropertyMobile(countryCode + phoneNumber);
			setPropertyLogo(response.data.result.property.logoUrl);
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	const getGuestCheckInOutRequests = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
			);
			dispatch(filterCheckInOutRequsts(response.data.result));
			dispatch(setGuestCheckInOutRequests(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};
	const getGuestAddons = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/addOns`,
			);
			dispatch(filterAddOnRequests(response.data.result));
			dispatch(setGuestAddons(response.data.result));
		} catch (error) {
			console.error("Error fetching guest data:", error);
		}
	};

	const getMultiGuestSessionId = () => {
		const id = JSON.parse(localStorage.getItem("multiGuestSessionId"));
		if (id) {
			setMultiGuestSessionId(id);
		}
	};

	useEffect(() => {
		//console.warn("USE EFFECT")
		getGuest();
		getGuestPropertyData();
		getGuestCheckInOutRequests();
		getGuestAddons();
		getMultiGuestSessionId();
	}, []);

	const getWorkFlow = async () => {
		try {
			const response = await axios.get(
				`${baseUrl}/guestApi/${guestSessionId}/workflow`,
			);

			setAminities(response.data.result.homeFlow.amenities);

			if (guest && guest.status.currentStatus === "Reservation") {
				setStatusFlow(response.data.result.homeFlow);
			} else if (guest && guest.status.currentStatus === "In House") {
				setStatusFlow(response.data.result.inHouseFlow);
			} else if (guest && guest.status.currentStatus === "Checked Out") {
				setStatusFlow(response.data.result.checkedOutFlow);
			}
			setPropertyCheckOutTime(
				response.data.result.settingFlow.standardCheckoutTime,
			);

			if (
				response.data.result &&
				response.data.result.addOnsFlow &&
				response.data.result.addOnsFlow.checkInOutAddOns.length > 0 &&
				response.data.result.addOnsFlow.checkInOutAddOns[1].enabled
			)
				setPropertyLateCheckOutTime(
					response.data.result.addOnsFlow.checkInOutAddOns[1],
				);
			const tempArr = [
				...response.data.result.addOnsFlow.checkInOutAddOns,
				...response.data.result.addOnsFlow.customAddOns,
				response.data.result.addOnsFlow.houseKeepingAddOns,
			];
			console.log(tempArr);

			setAddOns(tempArr);
		} catch (error) {
			console.error("Error fetching workflow:", error);
		}
	};

	useEffect(() => {
		if (guest) {
			getWorkFlow();
			// Redirect to Rating if reservationStatus is "Cancelled"
			// if (guest.reservationStatus === "Cancelled" || guest.status?.reservationStatus === "Cancelled") {
			// 	navigate("/rating", {
			// 		state: { guest, guestSessionId },
			// 	});
			// }
		}
	}, [guest]);

	const isOverlayClosed = (index) => {
		return sessionStorage.getItem(`overlayClosed_${index}`) === "true";
	};

	const handleOverlayClose = (index) => {
		sessionStorage.setItem(`overlayClosed_${index}`, "true");
	};

	const handleWifiModalOpen = (open) => {
		setIsWifiModalOpen(open);
	};

	const handleBackClick = () => {
		navigate(`/list/${multiGuestSessionId}`);
	}

	return (
		<div className="fixed inset-0 bg-gray-900 flex flex-col">
			<div className="flex-1 overflow-y-auto webkit-overflow-scrolling-touch">
				<div className="min-h-full">
					{!guest && <LoadingSpinner />}
					{guest && (
						<Navbar
							first={guest.firstName}
							last={guest.lastName}
							propertyMobile={propertyMobile}
							propertyLogo={propertyLogo}
						/>
					)}
					{multiGuestSessionId && (
						<div className="p-5 pb-0">
							<button type="button" 	className="bg-none border-none 	text-white flex items-center gap-2"
							onClick={handleBackClick}
							>
								<FaArrowLeft />
								<span>Back to List</span>
							</button>
						</div>
					)}
					{guest && (
						<Modal
							guest={guest}
							propertyLateCheckOutTime={propertyLateCheckOutTime}
							propertyCheckOutTime={propertyCheckOutTime}
							selectedTime={selectedTime}
							selectedDate={selectedDate}
							setSelectedTime={setSelectedTime}
							setSelectedDate={setSelectedDate}
							addOns={addOns}
							propertyMobile={propertyMobile}
						/>
					)}
					{guest &&
						guest.status.currentStatus === "In House" &&
						statusFlow &&
						statusFlow.wifiDetailsEnabled && (
							<WifiModal
								statusFlow={statusFlow}
								setOverlayVisible={setOverlayVisible}
								setIsWifiModalOpen={handleWifiModalOpen}
							/>
						)}
					{/* {guest && guest.status.currentStatus === "Checked Out" && (
        <ThanksgiftModal />
      )} */}
					{guest && guest.status.currentStatus === "In House" && (
						<DoNotDisturb
							guestId={guestid}
							guestSessionId={guestSessionId}
							guest={guest}
							setGuest={setGuest}
						/>
					)}
					{guest && guest?.status?.currentStatus !== "Checked Out" && guest.status.reservationStatus !== "Cancelled" && (
						<ServiceContainer />
					)}
					{guest && !isWifiModalOpen && (
						<PreArrivalModal
							guest={guest}
							getGuest={getGuest}
							guestSessionId={guestSessionId}
						/>
					)}
					{guest &&
						guest.status.currentStatus !== "Checked Out" && guest.status.reservationStatus !== "Cancelled" &&
						amenities && <Amenities amenities={amenities} />}
					{statusFlow && <Faq statusFlow={statusFlow} />}
					{guest && overlayVisible && (
						<div className="pb-4 pl-4 fixed bottom-0 left-0 flex space-x-4">
							{overlays.map(
								(overlay, index) =>
									!isOverlayClosed(index) && (
										<ChatOverlay
											key={index}
											heading={overlay.heading}
											name={overlay.name}
											number={overlay.number}
											onClose={() => handleOverlayClose(index)}
											propertyMobile={propertyMobile}
										/>
									),
							)}
						</div>
					)}
				</div>
				<div className="text-center mb-6 mt-12 text-gray-50 text-sm">
					Powered By Onelyk.Com
					<div className="mt-2 space-x-4">
						<a href="/terms" className="text-blue-400 hover:underline">
							Terms and Conditions
						</a>
						<a href="/privacy" className="text-blue-400 hover:underline">
							Privacy Policy
						</a>
					</div>
				</div>
			</div>
		</div>
		// <div className="bg-gray-900 h-screen overflow-y-auto">

		// </div>
	);
};

export default Home;
